import React from 'react';
import {useMuseumFilterState} from "./museumFilterContext";
import {Box, Paper, Slide, Toolbar} from "@mui/material";
import {ExpandedToolbar} from "./ExpandedToolbar";
import {CollapsedToolbar} from "./CollapsedToolbar";


export const SideSheetMuseumFilter = ({children}) => {
    const {
        open,
        expanded
    } = useMuseumFilterState();

    const toolbar = {
        true: <ExpandedToolbar />,
        false: <CollapsedToolbar />

    }

    if(open) {
        return (
            <Slide
                in={open}
                direction={"left"}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "row-reverse",
                    }}
                >
                    <div>
                        <Paper
                            sx={{
                                width: expanded ? 300 : 88,
                                height: "100%",
                                overflowY: "auto"
                            }}
                        >
                            <Toolbar/>
                            <Box
                                sx={{
                                    position: "relative",
                                }}
                            >
                                <Toolbar disableGutters={false}>
                                    {toolbar[expanded]}
                                </Toolbar>
                                {children}
                            </Box>
                        </Paper>
                    </div>
                </Box>
            </Slide>
        )
    } else {
        return null;
    }

}